// export { default as UserLayout } from "./customer/userLayout/UserLayout";
// export { default as CustomerPanelLayout } from "./customer/panelLayout/CustomerPanelLayout";
// export { default as VenderLayout } from "./vender/VenderLayout";
export { default as LoginLayout } from "./loginLayout/LoginLayout";
export { default as PanelLayout } from "./panelLayout/PanelLayout";
